var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['notification', _vm.notificationClass, _vm.animationClass],on:{"transitionend":_vm.handleTransitionEnd}},[_c('div',{staticClass:"notification-content"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }